<template>

    <div id="report-index">

        <div class="py-6" v-if="loaded">

            <div class="grid grid-cols-4 gap-6" v-if="form.indexHasResults()">

                <a href="#" class="panel col-span-4 xl:col-span-1 cursor-pointer border-4 hover:border-brand-500" v-for="(report) in form.index_data.data" @click.prevent="showReport(report)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-40 w-40 mx-auto text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false" role="img" :aria-label="report.name">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                    </svg>
                    <h2 :id="report.name" class="font-medium text-gray-800">
                        {{ ellipsis(report.name, 32) }}
                    </h2>
                    <p class="text-sm text-gray-500">
                        {{ ellipsis(report.description, 40) }}
                    </p>
                </a>

            </div>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Reports Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        There are no reports available right now, please contact support.
                    </p>
                </div>
            </div>
            <infinite-loading class="py-6 text-center text-xs uppercase font-medium text-gray-600" @infinite="infiniteHandler">
                <div slot="no-results">No Reports</div>
                <div slot="no-more">&nbsp;</div>
                <div slot="error">An Error Occurred, contact support.</div>
                <div slot="spinner"><Loading></Loading></div>
            </infinite-loading>

        </div>
        <Loading message="Loading Reports" v-else></Loading>

    </div>

</template>

<script>

import {ReportIndexes} from "../../app/Report/ReportIndexes";
import Loading from "../Support/Loading";
import InfiniteLoading from "vue-infinite-loading";
import {FormattingMixin} from "../../support/mixins";

export default {
    name: "ReportIndex",
    mixins: [FormattingMixin],
    components: {
        InfiniteLoading,
        Loading
    },
    data() {
        return {
            form: false,
            loaded: false,
        }
    },
    methods: {
        showReport(payload) {
            this.$emit('showReport', payload);
        },
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(r => {
                    $state.loaded();
                }).catch(error => vm.handleError(error));
            } else {
                $state.loaded();
                $state.complete();
            }
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new ReportIndexes();

            vm.form.index().then(r => {
                resolve(true);
            }).then(r => {
                vm.loaded = true;
            }).catch(error => vm.handleError(error));
        });
    }
}
</script>
